import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  vertical-align: text-bottom;\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  transition: transform 0.3s ease-in-out, fill 0.15s ease-out;\n  ", "\n  ", "\n  & .tui-color-secondary {\n    transition: fill 0.15s ease-out;\n    ", "\n    ", "\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  box-sizing: content-box;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { isDefined } from '../helpers/defined';
import { NIGHTINGALE_BLACK } from '../colors';
import { getDefined } from '../helpers/common';
import { size } from '../style/size';
import { height } from '../style/height';
import { width } from '../style/width';
export var svgSizeStyle = css(_templateObject(), function (_ref) {
  var value = _ref.size;
  return isDefined(value) && size(value);
}, function (_ref2) {
  var value = _ref2.width;
  return isDefined(value) && width(value);
}, function (_ref3) {
  var value = _ref3.height;
  return isDefined(value) && height(value);
});
export var svgColorStyle = css(_templateObject2(), function (_ref4) {
  var _ref4$color = _ref4.color,
      color = _ref4$color === void 0 ? NIGHTINGALE_BLACK : _ref4$color;
  return color && "fill: " + color + ";";
}, function (_ref5) {
  var colorHover = _ref5.colorHover,
      colorActive = _ref5.colorActive;
  return getDefined(colorHover, colorActive) && "\n    &:hover {\n      fill: " + getDefined(colorHover, colorActive) + ";\n    }\n  ";
}, function (_ref6) {
  var colorSecondary = _ref6.colorSecondary;
  return colorSecondary && "fill: " + colorSecondary + ";";
}, function (_ref7) {
  var colorSecondaryHover = _ref7.colorSecondaryHover,
      colorSecondaryActive = _ref7.colorSecondaryActive;
  return getDefined(colorSecondaryHover, colorSecondaryActive) && "\n      &:hover {\n        fill: " + getDefined(colorSecondaryHover, colorSecondaryActive) + ";\n      }\n    ";
});
export var svgDisplayStyle = css(_templateObject3(), function (_ref8) {
  var flex = _ref8.flex;
  return flex && "\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n  ";
});
export var svgPointerStyle = css(_templateObject4(), function (_ref9) {
  var pointer = _ref9.pointer;
  return pointer && "cursor: pointer;";
});
export var svgKeys = ['color', 'colorHover', 'colorActive', 'colorSecondary', 'colorSecondaryHover', 'colorSecondaryActive', 'size', 'width', 'height', 'pointer', 'flex'];